<template>
  <b-container class="bv-example-row">
    <b-row class="display-flex">
      <b-col>
        <b-row align-v="center" align-h="center" class="mb-3">
          <b-col>
            <div class="pie-chart-loans">
              <doughnut-chart
                :dataToRender="dataToRender"
              />
              <div class="pie-information small-info">
                <div class="pie-information_title">
                  {{ selectedCompany.name }}
                </div>
                <div class="pie-information_value">
                  {{ formatInnerText(selectedCompany) }}
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col class="centered-column should-be-first-on-mobile">
        <b-row>
          <b-col>
            <div class="company-details">
            <div class="clogo">
              <img class="clogo-img" :src="categoriesMap[selectedValue.value].companyLogo" alt=""/>
            </div>
            <div class="cheader">
              <a target="_blank" :href="'https://getincome.com/loan-originators/'+(categoriesMap[selectedValue.value].companyUrl==='FIN Yritysrahoitus'?'fin-yritysrahoitus':categoriesMap[selectedValue.value].companyUrl)">
                {{categoriesMap[selectedValue.value].companyName}}
              </a><div class="entity" v-if="categoriesMap[selectedValue.value].companyEntity">&nbsp;({{categoriesMap[selectedValue.value].companyEntity}})</div>
            </div>
          </div>
            <div class="chart-section-text">
              <div
                v-for="(section, index) in categoriesMap[selectedValue.value]
                  .data"
                :key="index"
                class="text-block"
                :class="{
                  'text-block__selected': section.name === selectedCompany.name,
                }"
                @click="() => (selectedCompany = section)"
              >
                <div
                  class="dot"
                  :style="{ backgroundColor: section.color }"
                ></div>
                <div class="section_text">{{ section.name }}
                  <help-tooltip v-if="section.help"
                      :tooltip-text="section.help"></help-tooltip>
                  <br>
                  {{ section.percent }}% / {{ section.amount | moneyFormatterWithCurrency(section.currency) }}
                  <span v-if="section.currency !== 'EUR' && section.amount_in_eur">
                     ({{ section.amount_in_eur | moneyFormatterWithCurrency('EUR') }})
                  </span>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DoughnutChart from '../DoughnutChart'
import { BContainer, BCol, BRow } from 'bootstrap-vue'
import HelpTooltip from '@/components/HelpTooltip'
import moneyMixin from '@/mixins/money'

export default {
  name: 'DoughnutChartDetailsSection',
  mixins: [moneyMixin],
  components: {
    DoughnutChart,
    BContainer,
    BRow,
    BCol,
    HelpTooltip
  },
  watch: {
    categories: {
      handler: function (newVal) {
        this.selectData.options = newVal.map(({ categoryName }) => ({
          value: categoryName,
          name: categoryName
        }))
        newVal.forEach((element) => {
          this.categoriesMap[element.categoryName] = element
        })
        if (newVal.length > 0) {
          this.selectedValue = { ...this.selectData.options[0] }
          //   this.dataToRender = newVal.data;
        }
      },
      immediate: true,
      deep: true
    },
    selectedValue: {
      handler: function (newVal) {
        this.selectedCompany = this.categoriesMap[newVal.value].data[0]
        this.sections = this.categoriesMap[newVal.value].data.map(
          ({ name, color }) => ({
            color,
            name
          })
        )
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    dataToRender() {
      return this.categoriesMap[this.selectedValue.value].data.map(
        ({ amount, name, color, percent }) => ({
          value: this.selectedMode ? percent : amount,
          name,
          color,
          isSelected: name === this.selectedCompany.name
        })
      )
    }
  },
  data() {
    return {
      categoriesMap: {},
      selectedCompany: {},
      selectedValue: {},
      selectedMode: 1,
      selectData: {
        options: [
          { value: 'A', name: 'Option A (from options prop)' },
          { value: 'B', name: 'Option B (from options prop)' }
        ],
        closeOnSelect: true,
        searchable: false,
        clearOnSelect: false,
        placeholder: 'Please select one of the variants',
        // disabled: true,
        multiple: false,
        label: 'Multiselect Select required'
      },
      sections: []
    }
  },
  props: {
    dataSections: {
      type: Array,
      required: false,
      default: () => []
    },
    categories: {
      type: Array,
      required: false,
      default: () => []
    },
    inPercent: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    formatInnerText(section) {
      return this.selectedMode === 0 ? `€ ${section.amount}` : `${section.percent}%`
    }
  }
}
</script>
